// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toolbar Container - Clean & Modern */
:host {
  display: block;
  width: 100%;
}

.toolbar {
  background: transparent;
  /* Tight vertical rhythm across forms without changing button size */
  padding: clamp(0.25rem, 0.5vw, 0.4rem) 0.75rem;
  border-radius: 0.5rem;
  /* 8px radius for softer look */
  display: flex;
  align-items: center;
  gap: 0.5rem;
  /* 8px gap */
  box-shadow: none;
  border: none;
  transition: all 0.3s ease;
  margin: clamp(0.25rem, 0.6vw, 0.5rem) 0;
  flex-wrap: wrap;
  /* responsive */
}

/* Sections */
.toolbar-left,
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 6px;
}

.toolbar-right {
  margin-left: auto;
}

/* Base Button Styles */
.toolbar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  /* 4px between icon & label */
  padding: 1.5rem 1.5rem;

  /* btn-sm padding */
  border-radius: 0.375rem;
  /* 6px radius */
  font-size: 1.2rem;
  /* 14px */
  font-weight: 500;
  line-height: 1.2;
  border: 1px solid transparent;
  background-color: #3300ff;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  height: auto;
  width: auto;
}

/* Icon Styles */
.toolbar-btn i {
  font-size: 20px;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  line-height: 1;
  margin: 0.8rem;
}

/* Hover Effects - Background Animation */
.toolbar-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  background-color: #2800CC;
  box-shadow: 0 4px 12px rgba(51, 0, 255, 0.35);
  animation: buttonPulse 0.6s ease-in-out;
}

.toolbar-btn:active:not(:disabled) {
  transform: translateY(0px);
  box-shadow: 0 2px 6px rgba(51, 0, 255, 0.25);
}

/* Button Pulse Animation */
@keyframes buttonPulse {
  0% {
    box-shadow: 0 2px 6px rgba(51, 0, 255, 0.2);
  }

  50% {
    box-shadow: 0 6px 16px rgba(51, 0, 255, 0.4);
  }

  100% {
    box-shadow: 0 4px 12px rgba(51, 0, 255, 0.35);
  }
}

/* Outline Button Pulse Animation */
@keyframes outlineButtonPulse {
  0% {
    box-shadow: 0 1px 3px rgba(169, 169, 169, 0.15);
  }

  50% {
    box-shadow: 0 4px 10px rgba(169, 169, 169, 0.3);
  }

  100% {
    box-shadow: 0 3px 8px rgba(169, 169, 169, 0.25);
  }
}

/* Button Variants */

/* Primary / Blue (Default) */
.btn-bluelight,
.btn-primary-soft {
  background-color: #3300FF;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(51, 0, 255, 0.2);
  height: 37px;
}

.btn-bluelight:hover:not(:disabled),
.btn-primary-soft:hover:not(:disabled) {
  background-color: #2800CC;
  box-shadow: 0 4px 12px rgba(51, 0, 255, 0.35);
  animation: buttonPulse 0.6s ease-in-out;
}

.btn-bluelight:disabled,
.btn-primary-soft:disabled {
  background-color: #6d28d9;
  box-shadow: none;
}

/* Outline / Print & Export Buttons */
.btn-outline {
  background: #9FA6BB;
  border: none;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(169, 169, 169, 0.2);
  height: 37px;
}

.btn-outline:hover:not(:disabled) {
  background: #8C8C8C;
  box-shadow: 0 4px 12px rgba(169, 169, 169, 0.35);
  animation: outlineButtonPulse 0.6s ease-in-out;
}

.btn-outline:disabled {
  background: #9FA6BB;
  color: #ffffff;
  box-shadow: none;
}

/* Danger Soft */
.btn-danger-soft {
  background: #ef4444;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.2);
  height: 37px;
}

.btn-danger-soft:hover:not(:disabled) {
  background: #dc2626;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.35);
}

.btn-danger-soft:disabled {
  background: #fca5a5;
  box-shadow: none;
}

/* Success Soft */
.btn-success-soft {
  background: #10b981;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.2);
  height: 37px;
}

.btn-success-soft:hover:not(:disabled) {
  background: #059669;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
}

.btn-success-soft:disabled {
  background: #6ee7b7;
  box-shadow: none;
}

/* Ghost */
.btn-ghost {
  background: transparent;
  color: #6b7280;
  box-shadow: none;
  height: 37px;
}

.btn-ghost i {
  color: #6b7280;
}

.btn-ghost:hover:not(:disabled) {
  background: rgba(51, 0, 255, 0.08);
  color: #3300FF;
}

.btn-ghost:hover:not(:disabled) i {
  color: #3300FF;
}

.btn-ghost:disabled {
  background: transparent;
  color: #d1d5db;
}

.btn-ghost:disabled i {
  color: #d1d5db;
}

/* Icon Only Button */
.btn-icon {
  padding: 0;
  width: 37px;
  height: 37px;
  aspect-ratio: 1;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Disabled State */
.toolbar-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
  transform: none;
}

/* RTL Support */
:host-context([dir="rtl"]) .toolbar-right,
[dir="rtl"] .toolbar-right {
  margin-left: 0;
  margin-right: auto;
}

.toolbar.rtl .toolbar-right {
  margin-left: 0;
  margin-right: auto;
}

/* ------------------------------------------------------------
   Split Dropdown Button – unified look inside toolbar
   ------------------------------------------------------------ */

/* Wrapper btn-group inherits toolbar-left/right gap but
   we collapse the internal gap so the two buttons touch */
.toolbar-left .btn-group,
.toolbar-right .btn-group {
  display: inline-flex;
  align-items: stretch;
  gap: 0;                        /* no space between main btn and toggle */
}

/* Main action button: square right side (LTR) / left side (RTL) */
.toolbar-left .btn-group > .toolbar-btn:first-child,
.toolbar-right .btn-group > .toolbar-btn:first-child {
  border-start-end-radius: 0;    /* top-right  */
  border-end-end-radius: 0;      /* bottom-right */
  border-inline-end: 1px solid rgba(255,255,255,0.25); /* subtle divider */
}

/* Toggle arrow button: square left side (LTR) / right side (RTL) */
.toolbar-left .btn-group > .dropdown-toggle-split,
.toolbar-right .btn-group > .dropdown-toggle-split {
  border-start-start-radius: 0;  /* top-left  */
  border-end-start-radius: 0;    /* bottom-left */
  padding-inline: 0.55rem;       /* narrower than main btn */
  min-width: 28px;
}

/* Inherit height from variants */
.toolbar-left .btn-group > .toolbar-btn,
.toolbar-right .btn-group > .toolbar-btn {
  height: 37px;
}

/* Dropdown menu */
.toolbar-left .btn-group .dropdown-menu,
.toolbar-right .btn-group .dropdown-menu {
  min-width: 180px;
  border-radius: 0.375rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  padding: 0.25rem 0;
  z-index: 1055;
}

.toolbar-left .btn-group .dropdown-item,
.toolbar-right .btn-group .dropdown-item {
  padding: 0.45rem 1rem;
  font-size: 0.875rem;
  cursor: pointer;
}

.toolbar-left .btn-group .dropdown-item:hover,
.toolbar-right .btn-group .dropdown-item:hover {
  background-color: rgba(51,0,255,0.08);
  color: #3300FF;
}

/* Responsive */
@media (max-width: 768px) {
  .toolbar {
    flex-wrap: wrap;
    padding: 0.35rem 0.65rem;
  }

  .toolbar-left,
  .toolbar-right {
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
  }

  .toolbar-right {
    margin-left: 0;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }
}

/* ------------------------------------------------------------
   Table utilities – row height & column width helpers
   ------------------------------------------------------------ */
.table-row {
  height: 3rem;
  /* 48px comfortable row height */
}

/* Column width helpers */
.col-w-80 {
  width: 80px;
}

.col-w-120 {
  width: 120px;
}

.col-w-160 {
  width: 160px;
}

.col-w-auto {
  width: auto;
}

/* Apply vertical alignment for custom rows */
.table>tbody>tr.table-row>td,
.table>tbody>tr.table-row>th {
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/toolbar-v1/toolbar-v1.component.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,oEAAoE;EACpE,8CAA8C;EAC9C,qBAAqB;EACrB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,eAAe;AACjB;;AAEA,aAAa;AACb;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;;EAEtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA,2BAA2B;AAC3B;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,+CAA+C;EACjD;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA,oBAAoB;;AAEpB,6BAA6B;AAC7B;;EAEE,yBAAyB;EACzB,cAAc;EACd,2CAA2C;EAC3C,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;EAChD,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;0DAC0D;AAC1D;;EAEE,oBAAoB;EACpB,oBAAoB;EACpB,MAAM,yBAAyB,yCAAyC;AAC1E;;AAEA,kEAAkE;AAClE;;EAEE,0BAA0B,KAAK,eAAe;EAC9C,wBAAwB,OAAO,iBAAiB;EAChD,mDAAmD,EAAE,mBAAmB;AAC1E;;AAEA,mEAAmE;AACnE;;EAEE,4BAA4B,GAAG,cAAc;EAC7C,0BAA0B,KAAK,gBAAgB;EAC/C,uBAAuB,QAAQ,2BAA2B;EAC1D,eAAe;AACjB;;AAEA,iCAAiC;AACjC;;EAEE,YAAY;AACd;;AAEA,kBAAkB;AAClB;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;;IAEE,eAAe;IACf,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yCAAyC;EAC3C;AACF;;AAEA;;iEAEiE;AACjE;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,6CAA6C;AAC7C;;EAEE,sBAAsB;AACxB","sourcesContent":["/* Toolbar Container - Clean & Modern */\n:host {\n  display: block;\n  width: 100%;\n}\n\n.toolbar {\n  background: transparent;\n  /* Tight vertical rhythm across forms without changing button size */\n  padding: clamp(0.25rem, 0.5vw, 0.4rem) 0.75rem;\n  border-radius: 0.5rem;\n  /* 8px radius for softer look */\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  /* 8px gap */\n  box-shadow: none;\n  border: none;\n  transition: all 0.3s ease;\n  margin: clamp(0.25rem, 0.6vw, 0.5rem) 0;\n  flex-wrap: wrap;\n  /* responsive */\n}\n\n/* Sections */\n.toolbar-left,\n.toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.toolbar-right {\n  margin-left: auto;\n}\n\n/* Base Button Styles */\n.toolbar-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  /* 4px between icon & label */\n  padding: 1.5rem 1.5rem;\n\n  /* btn-sm padding */\n  border-radius: 0.375rem;\n  /* 6px radius */\n  font-size: 1.2rem;\n  /* 14px */\n  font-weight: 500;\n  line-height: 1.2;\n  border: 1px solid transparent;\n  background-color: #3300ff;\n  color: #fff;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  height: auto;\n  width: auto;\n}\n\n/* Icon Styles */\n.toolbar-btn i {\n  font-size: 20px;\n  transition: transform 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  line-height: 1;\n  margin: 0.8rem;\n}\n\n/* Hover Effects - Background Animation */\n.toolbar-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  background-color: #2800CC;\n  box-shadow: 0 4px 12px rgba(51, 0, 255, 0.35);\n  animation: buttonPulse 0.6s ease-in-out;\n}\n\n.toolbar-btn:active:not(:disabled) {\n  transform: translateY(0px);\n  box-shadow: 0 2px 6px rgba(51, 0, 255, 0.25);\n}\n\n/* Button Pulse Animation */\n@keyframes buttonPulse {\n  0% {\n    box-shadow: 0 2px 6px rgba(51, 0, 255, 0.2);\n  }\n\n  50% {\n    box-shadow: 0 6px 16px rgba(51, 0, 255, 0.4);\n  }\n\n  100% {\n    box-shadow: 0 4px 12px rgba(51, 0, 255, 0.35);\n  }\n}\n\n/* Outline Button Pulse Animation */\n@keyframes outlineButtonPulse {\n  0% {\n    box-shadow: 0 1px 3px rgba(169, 169, 169, 0.15);\n  }\n\n  50% {\n    box-shadow: 0 4px 10px rgba(169, 169, 169, 0.3);\n  }\n\n  100% {\n    box-shadow: 0 3px 8px rgba(169, 169, 169, 0.25);\n  }\n}\n\n/* Button Variants */\n\n/* Primary / Blue (Default) */\n.btn-bluelight,\n.btn-primary-soft {\n  background-color: #3300FF;\n  color: #ffffff;\n  box-shadow: 0 2px 6px rgba(51, 0, 255, 0.2);\n  height: 37px;\n}\n\n.btn-bluelight:hover:not(:disabled),\n.btn-primary-soft:hover:not(:disabled) {\n  background-color: #2800CC;\n  box-shadow: 0 4px 12px rgba(51, 0, 255, 0.35);\n  animation: buttonPulse 0.6s ease-in-out;\n}\n\n.btn-bluelight:disabled,\n.btn-primary-soft:disabled {\n  background-color: #6d28d9;\n  box-shadow: none;\n}\n\n/* Outline / Print & Export Buttons */\n.btn-outline {\n  background: #9FA6BB;\n  border: none;\n  color: #ffffff;\n  box-shadow: 0 2px 6px rgba(169, 169, 169, 0.2);\n  height: 37px;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #8C8C8C;\n  box-shadow: 0 4px 12px rgba(169, 169, 169, 0.35);\n  animation: outlineButtonPulse 0.6s ease-in-out;\n}\n\n.btn-outline:disabled {\n  background: #9FA6BB;\n  color: #ffffff;\n  box-shadow: none;\n}\n\n/* Danger Soft */\n.btn-danger-soft {\n  background: #ef4444;\n  color: #ffffff;\n  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.2);\n  height: 37px;\n}\n\n.btn-danger-soft:hover:not(:disabled) {\n  background: #dc2626;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.35);\n}\n\n.btn-danger-soft:disabled {\n  background: #fca5a5;\n  box-shadow: none;\n}\n\n/* Success Soft */\n.btn-success-soft {\n  background: #10b981;\n  color: #ffffff;\n  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.2);\n  height: 37px;\n}\n\n.btn-success-soft:hover:not(:disabled) {\n  background: #059669;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);\n}\n\n.btn-success-soft:disabled {\n  background: #6ee7b7;\n  box-shadow: none;\n}\n\n/* Ghost */\n.btn-ghost {\n  background: transparent;\n  color: #6b7280;\n  box-shadow: none;\n  height: 37px;\n}\n\n.btn-ghost i {\n  color: #6b7280;\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background: rgba(51, 0, 255, 0.08);\n  color: #3300FF;\n}\n\n.btn-ghost:hover:not(:disabled) i {\n  color: #3300FF;\n}\n\n.btn-ghost:disabled {\n  background: transparent;\n  color: #d1d5db;\n}\n\n.btn-ghost:disabled i {\n  color: #d1d5db;\n}\n\n/* Icon Only Button */\n.btn-icon {\n  padding: 0;\n  width: 37px;\n  height: 37px;\n  aspect-ratio: 1;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Disabled State */\n.toolbar-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  pointer-events: none;\n  transform: none;\n}\n\n/* RTL Support */\n:host-context([dir=\"rtl\"]) .toolbar-right,\n[dir=\"rtl\"] .toolbar-right {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n.toolbar.rtl .toolbar-right {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n/* ------------------------------------------------------------\n   Split Dropdown Button – unified look inside toolbar\n   ------------------------------------------------------------ */\n\n/* Wrapper btn-group inherits toolbar-left/right gap but\n   we collapse the internal gap so the two buttons touch */\n.toolbar-left .btn-group,\n.toolbar-right .btn-group {\n  display: inline-flex;\n  align-items: stretch;\n  gap: 0;                        /* no space between main btn and toggle */\n}\n\n/* Main action button: square right side (LTR) / left side (RTL) */\n.toolbar-left .btn-group > .toolbar-btn:first-child,\n.toolbar-right .btn-group > .toolbar-btn:first-child {\n  border-start-end-radius: 0;    /* top-right  */\n  border-end-end-radius: 0;      /* bottom-right */\n  border-inline-end: 1px solid rgba(255,255,255,0.25); /* subtle divider */\n}\n\n/* Toggle arrow button: square left side (LTR) / right side (RTL) */\n.toolbar-left .btn-group > .dropdown-toggle-split,\n.toolbar-right .btn-group > .dropdown-toggle-split {\n  border-start-start-radius: 0;  /* top-left  */\n  border-end-start-radius: 0;    /* bottom-left */\n  padding-inline: 0.55rem;       /* narrower than main btn */\n  min-width: 28px;\n}\n\n/* Inherit height from variants */\n.toolbar-left .btn-group > .toolbar-btn,\n.toolbar-right .btn-group > .toolbar-btn {\n  height: 37px;\n}\n\n/* Dropdown menu */\n.toolbar-left .btn-group .dropdown-menu,\n.toolbar-right .btn-group .dropdown-menu {\n  min-width: 180px;\n  border-radius: 0.375rem;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n  padding: 0.25rem 0;\n  z-index: 1055;\n}\n\n.toolbar-left .btn-group .dropdown-item,\n.toolbar-right .btn-group .dropdown-item {\n  padding: 0.45rem 1rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.toolbar-left .btn-group .dropdown-item:hover,\n.toolbar-right .btn-group .dropdown-item:hover {\n  background-color: rgba(51,0,255,0.08);\n  color: #3300FF;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .toolbar {\n    flex-wrap: wrap;\n    padding: 0.35rem 0.65rem;\n  }\n\n  .toolbar-left,\n  .toolbar-right {\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .toolbar-right {\n    margin-left: 0;\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid rgba(0, 0, 0, 0.08);\n  }\n}\n\n/* ------------------------------------------------------------\n   Table utilities – row height & column width helpers\n   ------------------------------------------------------------ */\n.table-row {\n  height: 3rem;\n  /* 48px comfortable row height */\n}\n\n/* Column width helpers */\n.col-w-80 {\n  width: 80px;\n}\n\n.col-w-120 {\n  width: 120px;\n}\n\n.col-w-160 {\n  width: 160px;\n}\n\n.col-w-auto {\n  width: auto;\n}\n\n/* Apply vertical alignment for custom rows */\n.table>tbody>tr.table-row>td,\n.table>tbody>tr.table-row>th {\n  vertical-align: middle;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
